import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Active tenant slug — set by TenantScope on route entry.
let currentSlug = null;
export const setTenantSlug = (slug) => {
    currentSlug = slug || null;
};
export const getTenantSlug = () => currentSlug;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Auto-prefix tenant-scoped calls with /t/{slug}/... when a slug is active.
// Paths starting with /t/, /super/, /signup, /identity, /me, /health are passthrough.
const PASSTHROUGH_PREFIXES = ["/t/", "/super/", "/signup", "/identity/", "/me/", "/health"];

api.interceptors.request.use((config) => {
    const url = config.url || "";
    const isPassthrough = PASSTHROUGH_PREFIXES.some((p) => url.startsWith(p) || url === p.replace(/\/$/, ""));
    if (currentSlug && !isPassthrough) {
        const path = url.startsWith("/") ? url : `/${url}`;
        config.url = `/t/${currentSlug}${path}`;
    }
    return config;
});

// A helper for making requests without the tenant prefix (marketing, /me, super-admin).
export const apiRaw = axios.create({ baseURL: API, withCredentials: true });
